import { useEffect } from 'react';
import { SITE_NAME } from './ui';

/**
 * What the tab says.
 *
 * **The storefront's layout did this and there is no layout any more.**
 * `Base.astro` composed `<title>{page} — GOODBUILD</title>` for every public
 * page, and this bundle ships one `index.html` with one `<title>` in it — so
 * without this, every page of the shop, every store page and all three legal
 * documents share the single word `GOODBUILD`. A person with four tabs open
 * cannot tell which is the game they were reading.
 *
 * A hook rather than a prop on `Page`, because the two are not the same
 * question. `Page` draws the chrome and is rendered by every screen in the
 * application, including thirty signed-in ones that have always been called
 * `GOODBUILD` and are behind a sign-in where a tab title buys nothing. This is
 * called by the pages somebody arrives at from outside and might keep open.
 *
 * The same composition rule the layout used: the site's own name stands alone
 * and everything else is suffixed with it, so `GOODBUILD — GOODBUILD` cannot
 * happen.
 *
 * `null` while a title is still being fetched — a store page does not know the
 * game's name until the request lands — and the tab keeps whatever it had
 * rather than flashing the word `null` and correcting itself.
 */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title === null) return;
    document.title = title === SITE_NAME ? title : `${title} — ${SITE_NAME}`;

    /*
     * Put back on the way out, so a signed-in screen reached from a store page
     * does not inherit the game's name. Those screens do not call this hook, so
     * nothing else would ever set the tab back.
     */
    return () => {
      document.title = SITE_NAME;
    };
  }, [title]);
}
